
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url, type = 'website' }) => {
    const siteTitle = "Marvelous Agri Solution";
    const defaultDescription = "Empowering Farmers, Enriching Soil, Ensuring Food Security. Next-generation agricultural solutions for a sustainable future.";
    const defaultKeywords = "Agriculture Solutions, Smart Farming, Precision Agriculture, Agri Technology, Digital Agriculture, AI in Agriculture, Crop Advisory";
    const defaultImage = "/logo192.png"; // Ensure this exists or use a better default
    const siteUrl = "https://marvelousagrisolution.com"; // Replace with actual domain

    const metaTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const metaDescription = description || defaultDescription;
    const metaKeywords = keywords || defaultKeywords;
    const metaImage = image ? `${siteUrl}${image}` : `${siteUrl}${defaultImage}`;
    const metaUrl = url ? `${siteUrl}${url}` : siteUrl;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <link rel="canonical" href={metaUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={metaTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={metaImage} />
            <meta property="og:url" content={metaUrl} />
            <meta property="og:site_name" content={siteTitle} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={metaImage} />

            {/* Schema.org JSON-LD */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": siteTitle,
                    "url": siteUrl,
                    "logo": `${siteUrl}/logo192.png`,
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+91-1234567890", // Update with real number
                        "contactType": "Customer Service"
                    },
                    "sameAs": [
                        "https://www.facebook.com/marvelousagri",
                        "https://twitter.com/marvelousagri",
                        "https://www.instagram.com/marvelousagri"
                    ]
                })}
            </script>
        </Helmet>
    );
};

export default SEO;
